import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss/layout';
import { Subscription } from 'rxjs';
import { PortfolioService } from '../../../shared/services/portfolio.service';
import { PortfolioType } from '../../../shared/emuns/portfolio-type';
import {
  AccountManagerInformationService,
  IAccountManagerInformation
} from '../../services/account-manager-information.service';
import { FullPortfolioViewService } from '../../../shared/services/full-portfolio-view.service';

@Component({
  selector: 'ab-account-manager-information',
  templateUrl: './account-manager-information.component.html',
  styleUrls: ['./account-manager-information.component.scss']
})
export class AccountManagerInformationComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;

  public isPortfolioCorporate: boolean = undefined;
  public accountManagerName: string;
  public accountManagerPhone: string;
  public accountManagerEmail: string;

  private subscriptions: Subscription[] = [];

  constructor(
    private portfolioService: PortfolioService,
    private accountManagerInformationService: AccountManagerInformationService,
    private fullPortfolioViewService: FullPortfolioViewService
  ) {}

  ngOnInit(): void {
    this.getPortfolioType();
  }

  getPortfolioType(): void {
    this.subscriptions.push(
      this.fullPortfolioViewService.getFullPortfolioView().subscribe(() => {
        this.subscriptions.push(
          this.portfolioService.getSelectedPortfolio().subscribe(portfolios => {
            this.isPortfolioCorporate =
              PortfolioType[portfolios[0]?.portfolioType] ===
              PortfolioType.Corporate;
            if (this.isPortfolioCorporate) {
              this.getAccountManagerInfo();
            }
          })
        );
      })
    );
  }

  getAccountManagerInfo(): void {
    this.subscriptions.push(
      this.accountManagerInformationService
        .getAccountManagerInformation()
        .subscribe((data: IAccountManagerInformation) => {
          this.accountManagerName = data?.name;
          this.accountManagerPhone = data?.phone;
          this.accountManagerEmail = data?.email;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
